import { ComponentProps, FC, ReactElement } from 'react'
import cn from 'classnames'

import ModuleWrapper2020 from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020'

import styles from 'components/features/rewards/rewardPage/RewardPage/RewardPageModuleWrapperPreset.styl'

type RewardPageModuleWrapperPresetProps = ComponentProps<typeof ModuleWrapper2020>

export const RewardPageModuleWrapper: FC<RewardPageModuleWrapperPresetProps> = (props): ReactElement => {
  return <ModuleWrapper2020 { ...props } noPadding cardClassName={ cn(styles.card, props.cardClassName) } />
}
